import React from "react";
import { Box, Container, TablePagination } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router";
import { ApiClient } from "../../api/client";
import { RateSetListResponse } from "../../api/rateSet";
import ListToolbar from "../../components/ListToolbar";
import { useAsync } from "../../components/Loading/useAsync";
import { useLoadableState } from "../../components/Loading/useLoadableState";
import RateSetListResults from "../../components/rateSets/RateSetListResults";

const RateSetList = () => {
  const navigate = useNavigate();
  const [rateSetsResponse, setRateSetsResponse] =
    useLoadableState<RateSetListResponse>({
      rate_sets: [],
      total_count: 0,
    });
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);

  const getPagedRateSetsResponse = React.useCallback(
    (client: ApiClient) => client.rate.set.getAll(page, rowsPerPage),
    [page, rowsPerPage]
  );

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | undefined
  ) => {
    const newRowsPerPage = parseInt(event?.target.value || "", 10);

    setRowsPerPage(isNaN(newRowsPerPage) ? 25 : newRowsPerPage);
    setPage(0);
  };

  const handlePageChange = (
    _: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  useAsync(getPagedRateSetsResponse, setRateSetsResponse);

  return (
    <>
      <Helmet>
        <title>Rate Set List</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <ListToolbar
            title="Rate Sets"
            newButtonTitle="Add rate set"
            newUrl="/app/rateSets/new"
          />
          <Box sx={{ pt: 3 }}>
            <RateSetListResults
              rateSetsResponse={rateSetsResponse}
              onClick={(x) => navigate(`/app/rateSet/${x}`)}
            >
              <TablePagination
                component="div"
                count={Number(rateSetsResponse?.data?.total_count) || 0}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                page={page}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[5, 10, 15]}
              />
            </RateSetListResults>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default RateSetList;
